module.exports = __webpack_public_path__ + "static/media/hcfcd-logoSmall.296349d4.png";